import { Trans } from "@lingui/react/macro";
import Chip from "@medoma/components/Chip/Chip";
import CustomProperties from "@medoma/components/CustomProperties/CustomProperties";
import type { IPatientNoteStatus } from "@medoma/models/patientNotes";
import styles from "./NoteStatusChip.module.scss";

type INoteStatusChip = {
  status: IPatientNoteStatus;
  children?: string;
};

export const NoteStatusChip = (props: INoteStatusChip) => {
  const { status, children } = props;

  return status === "accepted" ? (
    <CustomProperties className={styles.accepted}>
      <Chip border="solid">
        <Trans>Godkänd av {children}</Trans>
      </Chip>
    </CustomProperties>
  ) : (
    <CustomProperties className={styles.unsaved}>
      <Chip border="solid">
        <Trans>Ej sparad</Trans>
      </Chip>
    </CustomProperties>
  );
};
